import { Action, combineReducers, createFeatureSelector, createSelector } from '@ngrx/store';
import * as featureFlags from './feature-flags.reducers';

export const featureFlagsKey = 'featureFlags';

export interface FeatureFlagState { [featureFlags.flagsKey]: featureFlags.State; }

export function reducers(state: FeatureFlagState | undefined, action: Action) {
  return combineReducers({ [featureFlags.flagsKey]: featureFlags.featureFlagReducer })(state, action);
}

export const selectFeatureFlagsKey = createFeatureSelector<FeatureFlagState>(
  featureFlagsKey
);

export const selectFeatureFlags = createSelector(selectFeatureFlagsKey, (state) => {
  return state?.flags;
});

export const selectEnableCodeY4RecurringChecks = createSelector(selectFeatureFlags, (state) => {
  return state.enableCodeY4RecurringChecks;
});

export const selectEnableUseSloaContainer = createSelector(selectFeatureFlags, (state) => {
  return state.enableUseSloaContainer;
});

export const selectIsCreateSloaToggleFlagEnabled = createSelector(selectFeatureFlags, (state) => {
  return state.createSloaToggleForCreateRulesEnabled;
});

export const selectIsEnableTotalDistSloaBsloaIt = createSelector(selectFeatureFlags, (state) => {
  return state.enableTotalDistSloaBsloaIt;
});

export const selectIsEnablePALCreateWireTrxn = createSelector(selectFeatureFlags, (state) => {
  return state?.enablePALCreateWireTrxn;
});

export const selectIsEnableRecurringChecksStandingAuth = createSelector(selectFeatureFlags, (state) => {
  return state.enableRecurringChecksStandingAuth;
});

export const selectIsAchPathEnabled = createSelector(selectFeatureFlags, (state) => {
  return state.enableAchPath;
});

export const selectIsEnableWiresCondensedLayout = createSelector(selectFeatureFlags, (state) => {
  return state.enableWiresCondensedLayout;
});

export const selectIsEnableSpecialStateTax = createSelector(selectFeatureFlags, (state) => {
  return state.enableSpecialStateTax;
});
